import { StringStringMap } from 'src/app/core/models/common.models';

export const UPLOAD_ERRORS: Readonly<StringStringMap> = {
  'errors.fileExtensionNotAllowed': 'This file extension is not allowed.',
  'errors.fileIsLarge': 'The file could not be uploaded. Please make sure that the file size is less than 20 MB.',
};
